import { useEffect, useState } from 'react';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import './App.css';
import AboutPage from './AboutPage';
import ContactPage from './ContactPage';
import ImpactPage from './ImpactPage';
import GalleryPage from './GalleryPage';

function HomePage() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    document.title = 'Luckie Large | Entrepreneur, Investor & Philanthropist';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Luckie Large is an entrepreneur, investor, and philanthropist helping African founders grow with capital, mentorship, and opportunity.'
      );
    }
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const hero = document.querySelector('.hero');
      if (!hero) return;

      const currentImage = hero.style.backgroundImage.includes('image2') ? 'image2' : 'image1';
      const nextImage = currentImage === 'image1' ? 'image2' : 'image1';

      hero.style.backgroundImage = `linear-gradient(180deg, rgba(55, 35, 155, 0.72), rgba(99, 56, 247, 0.78)), url('/images/${nextImage}.jpg')`;
    }, 3500);

    return () => clearInterval(intervalId);
  }, []);

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Luckie Large',
    url: 'https://luckielarge.com',
    description: 'Luckie Large supports African founders with capital, mentorship, and market access.',
    founder: {
      '@type': 'Person',
      name: 'Luckie Large',
      alternateName: 'Luckie Large',
      jobTitle: 'Entrepreneur, Investor and Philanthropist',
      birthDate: '1976-08-13',
    },
  };

  return (
    <div className="landing">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <header className="hero">
        <div className="nav">
          <div className="brand-row">
            <span className="brand-mark" aria-hidden="true" />
            <span className="brand">Luckie Large </span>
          </div>

          <button
            className={`menu-toggle ${menuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation"
            aria-expanded={menuOpen}
          >
            <span />
            <span />
            <span />
          </button>

          <nav className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <Link to="/about" className="nav-link-button" onClick={closeMenu}>About</Link>
            <Link to="/impact" onClick={closeMenu}>Impact</Link>
            <Link to="/gallery" onClick={closeMenu}>Gallery</Link>
            <Link to="/contact" className="nav-cta" onClick={closeMenu}>Contact</Link>
          </nav>
        </div>

        <div className="hero-content">
          <p className="eyebrow">Luckie Large</p>
          <h1>Entrepreneur, Investor, Executive Leader, and Philanthropist.</h1>
          <p className="hero-copy">
            Luckie Large is a visionary business leader helping founders and growing businesses across Africa
            unlock capital, build stronger operations, and create long-term impact through mentorship and strategic
            opportunity.
          </p>
          <div className="hero-actions">
            <Link to="/about" className="btn btn-primary">About Luckie Large</Link>
            <Link to="/contact" className="btn btn-secondary">Connect</Link>
          </div>
        </div>
      </header>

      <main>
        <section id="about" className="section about">
          <div className="section-header">
            <span>About Luckie Large</span>
            <h2>Founder, investor, and business leader.</h2>
          </div>
          <div className="value-grid">
            <article className="value-card">
              <h3>Business Vision</h3>
              <p>
                Luckie Large built his career around creating opportunity, investing in growth, and helping
                visionary businesses become stronger and more sustainable. His leadership reflects a long-term view
                of entrepreneurship — one grounded in discipline, innovation, and practical action.
              </p>
            </article>
            <article className="value-card">
              <h3>Investment &amp; Impact</h3>
              <p>
                Through Luckie Large Investment Ltd, Luckie Large supports ventures across real estate,
                automotive services, and founder-focused growth. His work combines commercial insight with a commit-
                ment to community development, job creation, and ethical leadership.
              </p>
            </article>
          </div>
        </section>

        

        

        

        {/* <section id="contact" className="section cta">
          <div className="cta-card">
            <h2>Join the next generation of African businesses?</h2>
            <p>Apply today or contact our team to learn how we can support your growth journey.</p>
            <div className="hero-actions ">
              <Link to="/contact" className="btn btn-primary">Start Your Application</Link>
              <Link to="/contact" className="btn btn-secondary">Get in Touch</Link>
            </div>
          </div>
        </section> */}
      </main>

      <footer className="footer">
        <div className="footer-content">
          <p>Luckie Large © 2026 · Luckie Large Investment Ltd</p>
          <div className="footer-socials">
            <a href="https://www.linkedin.com/in/luckie-large-a399a0434/" target="_blank" rel="noopener noreferrer" className="social-link linkedin" aria-label="Connect on LinkedIn">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M6.94 8.5A1.56 1.56 0 1 1 6.94 5.4a1.56 1.56 0 0 1 0 3.1ZM5.5 9.6h2.9V18H5.5V9.6Zm4.7 0h2.77v1.14h.04c.39-.73 1.34-1.5 2.76-1.5 2.96 0 3.5 1.94 3.5 4.47V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18H31.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45c2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18h-2.9v-16.8h2.9v1.57c.7-1.2 2.02-2.45 4.15-2.45 2.78 0 4.36 1.82 4.36 5.62V18Z" fill="currentColor"/>
              </svg>
            </a>
            <a href="https://x.com/LuckieOLarge" target="_blank" rel="noopener noreferrer" className="social-link x" aria-label="Follow us on X">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M18.9 2h3.6l-7.85 8.97L22.7 22h-7.08l-5.54-7.24L3.92 22H.3l8.4-9.61L1.3 2h7.26l5.02 6.64L18.9 2zm-1.26 18h1.97L7.2 3.9H5.15L17.64 20z" fill="currentColor"/>
              </svg>
            </a>
            <a href="https://www.instagram.com/luckielarge_motors?utm_source=ig_web_button_share_sheet&igsi=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="social-link instagram" aria-label="Follow us on Instagram">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7zm5 3.5A5.5 5.5 0 1 1 6.5 13 5.5 5.5 0 0 1 12 7.5zm0 2A3.5 3.5 0 1 0 15.5 13 3.5 3.5 0 0 0 12 9.5zm5.25-3.38a1.13 1.13 0 1 1-1.13 1.13 1.13 1.13 0 0 1 1.13-1.13z" fill="currentColor"/>
              </svg>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/impact" element={<ImpactPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
